import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { CheckboxGroupValue } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { CheckboxContent } from '../CheckboxContent';
import { StyledCheckboxList } from '../StyledCheckboxContent';

export const useCreateCheckboxGroupAvailableValues = (
   medicalDataAccessAuthorization: MedicalDataAccessAuthorization[]
): CheckboxGroupValue[] => {
   const translate = useTranslate();

   return medicalDataAccessAuthorization.map((authorization) => ({
      key: `${authorization.id}`,
      label: (
         <CheckboxContent lastName={authorization.lastName.asString()} firstName={authorization.firstName.asString()}>
            <StyledCheckboxList>
               {authorization.forDocumentation ? (
                  <li>{translate(patientConsentsAndAuthorizationsTranslationKeys.printModal.medicalAccess)}</li>
               ) : null}
               {authorization.forInformation ? (
                  <li>{translate(patientConsentsAndAuthorizationsTranslationKeys.printModal.informationAccess)}</li>
               ) : null}
            </StyledCheckboxList>
         </CheckboxContent>
      ),
   }));
};
